<template>
  <div>
    <v-col cols="12 text-center">
      <p class="text-right mb-1 font-weight-medium">
        {{ dataField.title ? dataField.title : "" }}
      </p>
      <date-picker
        class="date-pick"
        v-model="dataPost[fieldName?fieldName.name:dataField.name]"
        :placeholder="dataField.placeHolder ? dataField.placeHolder : ''"
        @change="alerts[dataField.name] = null"
      >
    </date-picker>
    <v-alert  type="error" v-if="alerts[dataField.name] != null">{{alerts[dataField.name]}}</v-alert>
    </v-col>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "SahamsiDateBox",
  props: ["dataField","fieldName"],
  components: { datePicker: VuePersianDatetimePicker },
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
  data: () => ({
    required: [(v) => !!v || "اجباری می باشد"],
  }),
};
</script>
<style >
span.vpd-input-group{
  border-radius: 3px !important;
  height:55px !important;
}
</style>